<div *ngIf="formGroup"
     [formGroup]="formGroup">

  <div *ngIf="academicDegrees"
       class="row no-gutters mb-input-margin-bottom mb-title">
    <div ngbDropdown class="mb-custom-col-width field-wrapper" mbFloatingLabel>
      <label for="academicDegree" [ngClass]="[isFormDisabled ? 'mb-disable-label' : '', 'dropdown-label mb-custom-label']">{{ academicDegreeLabelKey | cxTranslate }}</label>
      <button [ngClass]="[isFormDisabled ? 'mb-disable-label' : '', 'w-100 btn btn-outline-primary mb-dropdown text-left mb-selected-dropdown-value text-initial']"
              id="academicDegree" name="academicDegree" type="button" ngbDropdownToggle [disabled]="isFormDisabled">
        {{ (selectedAcademicDegree?.code === constants?.ACADEMIC_DEGREE) ? (academicDegreeLabelKey | cxTranslate) : (selectedAcademicDegree?.name) }}
      </button>
      <div ngbDropdownMenu aria-labelledby="title-dropdown" data-cy="mb-title-input">
        <div ngbDropdownItem
             *ngFor="let academicDegree of academicDegrees"
             (click)="onAcademicDegreeChange(academicDegree)">
          {{academicDegree?.name}}
        </div>
      </div>
    </div>
  </div>

</div>
